import {
  projectIdToCompanyId
} from '../../utils/projectIdToCompanyId';

const protectedRoutes = ['/table', '/capacities', '/employees', '/projects', '/timesheet', '/work-reports'];

export default class ValidatePaidSubscription {
  resolveCompanyId(to, store) {
    let companyId = to.query.companyId || to.params.companyId;

    if (!companyId) {
      const projectId = to.query.projectId || to.params.projectId;
      companyId = projectIdToCompanyId(projectId, store.state.user.companies);
    }

    return companyId || null;
  }

  isEnabled(flag) {
    return flag === true || flag === 1 || flag === '1' || flag === 'true';
  }

  isActiveUntil(dateValue) {
    if (!dateValue) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return new Date(dateValue).getTime() >= today.getTime();
  }

  isValid(companyInfo) {
    const subscription = companyInfo?.subscription;

    if (!subscription) {
      return false;
    }

    const hasPaidSubscription =
      this.isActiveUntil(subscription.subscription_ends_at);
    const hasActiveTrial =
      this.isEnabled(subscription.is_trial) && this.isActiveUntil(subscription.trial_ends_at);

    return hasPaidSubscription || hasActiveTrial;
  }

  checkSubscriptionAccess(to, store) {
    if (!protectedRoutes.includes(to.path)) {
      return true;
    }

    const companyId = this.resolveCompanyId(to, store);
    const company = store.state.user.companies[companyId];

    return this.isValid(company);
  }
}
